// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pz-0";
export var leftAlign = "_pz-4";
export var listItem = "_pz-2";
export var listItemWrapper = "_pz-1";
export var operationText = "_pz-3";